import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *试卷库列表
 * @param params
 * 
*/

export const examList = params => Http.get(`${baseUrl}/exam`, { params })

/**
 *新建试卷
 * @param params
 * 
*/

export const saveExam = params => Http.post(`${baseUrl}/exam`,  params )

/**
 *删除试卷
 * @param examIds
 * 
*/

export const delExam = examIds => Http.delete(`${baseUrl}/exam/${examIds}` )

/**
 *试卷信息
 * @param examId
 * 
*/

export const examInfo = examId => Http.get(`${baseUrl}/exam/${examId}` )

/**
 *编辑试卷
 * @param params
 * 
*/

export const editExam = params => Http.put(`${baseUrl}/exam`, params )

/**
 *删除试卷试题
 * @param questionId
 * 
*/

export const delExamQuestion = questionId => Http.delete(`${baseUrl}/exam/question/${questionId}` )

/**
 *随机组卷
 * @param params
 * 
*/

export const randomSet = params => Http.post(`${baseUrl}/exam/random`, params )

/**
 *随机组卷列表
 * @param examId
 * 
*/

export const randomList = examId => Http.get(`${baseUrl}/exam/${examId}/children` )

/**
 *发放试卷列表
 * @param params
 * 
*/

export const releaseList = params => Http.get(`${baseUrl}/exam/release`, { params } )

/**
 *删除试卷
 * @param releaseId
 * 
*/

export const delReleaseExam = releaseId => Http.delete(`${baseUrl}/exam/release/${releaseId}` )

/**
 *试卷设置详情
 * @param releaseId
 * 
*/

export const releaseExamInfo = releaseId => Http.get(`${baseUrl}/exam/release/${releaseId}` )

/**
 *修改试卷设置
 * @param params
 * 
*/

export const editReleaseExam = params => Http.put(`${baseUrl}/exam/release`, params )

/**
 *发放试卷
 * @param params
 * 
*/

export const releaseExam = params => Http.post(`${baseUrl}/exam/release`, params )

/**
 *批阅列表
 * @param params
 * 
*/

export const reviewList = params => Http.get(`${baseUrl}/exam/release/receive`, { params } )

/**
 *统计数量
 * @param params
 * 
*/

export const reviewNum = params => Http.get(`${baseUrl}/exam/release/receive/count`, { params } )

/**
 *批阅详情
 * @param receiveId
 * 
*/

export const reviewInfo = receiveId => Http.get(`${baseUrl}/exam/release/receive/${receiveId}`)

/**
 *批阅
 * @param params
 * 
*/

export const submitReview = params => Http.put(`${baseUrl}/exam/release/receive/${params.receiveId}/review`, params.rList)

/**
 *打回
 * @param receiveId
 * 
*/

export const reviewBack = receiveId => Http.put(`${baseUrl}/exam/release/receive/${receiveId}/back`)

/**
 *导入到期末考试
 * @param releaseId
 * 
*/

export const setEnd = releaseId => Http.post(`${baseUrl}/exam/release/${releaseId}/end`)